<template>
    <div>
      <el-form label-width="100px" class="demo-ruleForm" style="height: 100%">
        <el-dialog 
          title="淤地坝图片导入" 
          :visible.sync="ydbPhotoImportDialogVisible" 
          :modal="false" 
          v-dialogDrag 
          :before-close="handleClose"
          :close-on-click-modal="false" 
          :show-close="true" 
          :close-on-press-escape="false"
        >
          <el-row class="rowTop" style="margin-top: 15px;">
            <el-col :span="24">
              <div class="titna">
                <span class="addSpan">图片</span>
              </div>
              <div class='fujian'>
                <el-upload 
                  class="upload-demo" 
                  drag 
                  action="" 
                  multiple 
                  :on-remove="handleRemove" 
                  :on-change='changes'
                  :file-list="fileList" 
                  :auto-upload='false'
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">可将多图片拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">
                    仅支持jpg/png格式图片，单文件最大10MB，<br/><br/>
                    <span style="color:red">文件名必须为【21位淤地坝编码-数字】（例：620123003100000000112-1.png）</span>
                  </div>
                </el-upload>
                <div class='fujian' v-if="filetabledata.length!=0" style="width: 100%;display: flexbox;">
                    <span style="color:blue">已上传的淤地坝图片列表如下：</span>
                  <ul>
                    <li v-for="(item,i) in filetabledata" :key="i" style="line-height: 28px">
                      <div style="text-align: left;display: flex;flex-direction: row;justify-content: space-between;margin-right: 6px;">
                        <div style="text-align: left;width: 600px;">
                          {{item.ydbSheng}}-{{item.ydbShi}}-{{item.ydbXian}}-{{item.ydbXiang}}-{{item.ydbCun}}-{{item.ydbName}}-{{item.ydbImagePath.split('/').pop()}}
                        </div>
                        <div>
                          <el-button type="primary" icon="el-icon-download" circle @click="DownloadFile(i,item)" class="btnmargin"></el-button>
                          <el-button type="danger" icon="el-icon-delete" circle @click="deletesfilesss(i,item)" class="btnmargin"></el-button>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </el-col>
          </el-row>
  
          <span slot="footer" class="dialog-footer">
            <el-form-item>
              <el-button round @click="empty()" type="warning">取消</el-button>
              <el-button round type="primary" @click="deteRmine('ruleForm')">保 存</el-button>
            </el-form-item>
          </span>
        </el-dialog>
      </el-form>
    </div>
  </template>
  
  <script>
  import { batchInsert, queryAll, ydbphotodelete } from "@/api/api";
  import addressTree from '@/components/mangement/popupaddressTree.vue';
  import axios from 'axios';
  
  export default {
    props: {
      mystate: Array
    },
    data() {
      return {
        states: "",
        ydbPhotoImportDialogVisible: true,
        urlsss: '/userApi/minio/updateFileMulti',
        minioDeleteUrl: '/userApi/minio/removeObject',
        fileList: [],
        filetabledata: [],
        downloadUrl: '/userApi/minio/downloadFile'
      };
    },
    components: {
      addressTree
    },
    methods: {
      // ======================================
      // 修正：新命名规则校验 21位数字-数字
      // ======================================
      validateYdbCodeFormat(fileName) {
        const reg = /^\d{21}-\d+$/;
        return reg.test(fileName);
      },
  
      // ======================================
      // 从文件名提取21位淤地坝编码
      // ======================================
      getRealYdbCode(fileName) {
        const mainName = fileName.split('.')[0];
        return mainName.split('-')[0];
      },
  
      // ======================================
      // 校验淤地坝编码是否存在
      // ======================================
      async checkYdbCodeExists(ydbCode) {
        try {
          const res = await axios.get('/userApi/ydb/basic/countByYdbCode', {
            headers: {
              "Content-Type": "application/json",
              "Access-Token": this.$store.state.token
            },
            params: { ydbCode }
          });
          return res.data.code === 200 && res.data.data;
        } catch (error) {
          console.error("校验淤地坝编码异常：", error);
          return false;
        }
      },
  
      // ===================== 删除逻辑 =====================
      deletesfilesss(index, item) {
        this.$confirm('确认删除此图片吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const fileName = item.ydbImagePath.split('/').pop();
          const id = item.id;
          const headers = { "Access-Token": this.$store.state.token };
  
          try {
            await axios.delete(`${this.minioDeleteUrl}/${fileName}`, { headers });
            await ydbphotodelete(id);
            this.filetabledata.splice(index, 1);
            this.$message.success("图片删除成功！");
          } catch (error) {
            console.error("删除失败：", error);
            this.$message.error("删除失败，请重试！");
          }
        }).catch(() => {
          this.$message.info('已取消删除');
        });
      },
  
      // 移除待上传文件
      handleRemove(file, fileList) {
        this.fileList = this.fileList.filter(f => f.name !== file.name);
      },
  
      // ======================================
      // 修正：文件选择校验（适配新命名）
      // ======================================
      changes(file, fileList) {
        const num = 1024.00;
        const fileSize = Number((file.size / Math.pow(num, 2)).toFixed(2));
        const fileExt = file.name.toLowerCase().split('.').pop();
        const allowExts = ['jpg', 'jpeg', 'png'];
        const mainName = file.name.split('.')[0];
  
        // 1. 大小校验
        if (fileSize > 10) {
          fileList.pop();
          this.$message.error('图片大于10MB，请重新选择！');
          return;
        }
        // 2. 格式校验
        if (!allowExts.includes(fileExt)) {
          fileList.pop();
          this.$message.error(`仅支持${allowExts.join('/')}格式！`);
          return;
        }
        // 3. 新命名规则校验
        if (!this.validateYdbCodeFormat(mainName)) {
          fileList.pop();
          this.$message.error('文件名不规范！必须是【21位编码-数字】！');
          return;
        }
        // 4. 添加到待上传列表
        if (!this.fileList.some(f => f.name === file.name)) {
          this.fileList.push(file.raw);
        }
      },
  
      // ======================================
      // 修正：保存上传（提取正确淤地坝编码）
      // ======================================
      async deteRmine(formName) {
        if (this.fileList.length === 0) {
          this.empty();
          return;
        }
  
        this.$message.info("正在校验淤地坝编码，请稍候...");
        const validFiles = [];
        const invalidMsg = [];
  
        for (const file of this.fileList) {
          // 提取真实21位淤地坝编码
          const realYdbCode = this.getRealYdbCode(file.name);
          const exists = await this.checkYdbCodeExists(realYdbCode);
          
          if (exists) {
            validFiles.push(file);
          } else {
            invalidMsg.push(`文件【${file.name}】：淤地坝编码不存在`);
          }
        }
  
        if (invalidMsg.length > 0) {
          this.$message.error(invalidMsg.join('\n'));
          return;
        }
        this.$message.success("所有淤地坝编码校验通过！");
  
        const uploadHeaders = {
          "Content-Type": "multipart/form-data",
          "Access-Token": this.$store.state.token
        };
        const batchInsertData = [];
        let successCount = 0;
  
        validFiles.forEach((file, index) => {
          const formData = new FormData();
          formData.append('file', file);
  
          axios.post(this.urlsss, formData, { headers: uploadHeaders }).then(res => {
            if (res.data.code === 200) {
              const minioFileName = res.data.data[0].fileName;
              const realYdbCode = this.getRealYdbCode(file.name);
              
              batchInsertData.push({ ydbCode: realYdbCode, fileName: minioFileName });
              successCount++;
  
              if (successCount === validFiles.length) {
                this.batchSaveToDb(batchInsertData);
              }
            } else {
              this.$notify.error(`第${index+1}张图片上传失败`);
            }
          }).catch(err => {
            this.$notify.error(`第${index+1}张图片上传异常`);
          });
        });
      },
  
      // 批量保存到数据库
      batchSaveToDb(data) {
        const saveHeaders = {
          "Content-Type": "application/json",
          "Access-Token": this.$store.state.token
        };
        batchInsert(data, { headers: saveHeaders }).then(res => {
          if (res.code === 200) {
            this.$notify.success('图片批量上传并保存成功');
            this.queryAllImages();
            this.fileList = [];
            this.empty();
          } else {
            this.$notify.error(`批量保存失败：${res.message}`);
          }
        }).catch(err => {
          this.$notify.error('批量保存异常，请重试');
        });
      },
  
      // 查询已上传列表
      queryAllImages() {
        const headers = {
          "Content-Type": "application/json",
          "Access-Token": this.$store.state.token
        };
        queryAll({}, { headers }).then(res => {
          if (res.code === 200) {
            this.filetabledata = res.data;
          }
        });
      },
  
      // 关闭弹窗
      empty() {
        this.$emit("getydbphotocancel");
      },
      handleClose() {
        this.$emit("getydbphotocancel");
      },
  
      // 下载图片
      DownloadFile(index, item) {
        const fileName = item.ydbImagePath.split('/').pop();
        const downloadUrl = `${this.downloadUrl}/${fileName}`;
        const headers = new Headers();
        headers.append('Access-Token', this.$store.state.token);
  
        fetch(downloadUrl, { method: 'GET', headers })
        .then(response => response.blob())
        .then(blob => {
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `${item.ydbName}_${fileName}`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch(() => this.$notify.error('图片下载失败'));
      }
    },
    mounted() {
      this.queryAllImages();
    }
  };
  </script>
  
  <style scoped="scoped">
  >>> .el-dialog { width: 1000px; }
  >>> .el-dialog__body { height: 450px; overflow: auto; }
  .fujian { width: calc(100% - 112px); float: right; border: 1px solid #ccc; border-radius: 4px; padding: 10px; overflow: auto; }
  .addSpan { line-height: 30px; margin-right: 10px; }
  .btnmargin{ margin-left: 6px; }
  </style>